<template>
  <div class="bracketing-section">
    <div>
      <div class="section-title">Bracketing</div>
      <div class="section-paragraph">
        You are not sure which settings work best and want to decide later?
        Besides bracketing via exposure correction Camoodo makes it possible to
        vary also other parameters. The range of up to 15 images with up to 5EV
        difference is easily enough for the most extreme requirements.
      </div>
    </div>
    <div class="section-paragraph images">
      <info-box caption="Exposure Compensation">
        <q-img
          src="images\brk_exposure_compensation_1.jpg"
          :ratio="16 / 9"
        ></q-img>
        <q-img
          src="images\brk_exposure_compensation_2.jpg"
          :ratio="16 / 9"
        ></q-img>
        <q-img
          src="images\brk_exposure_compensation_3.jpg"
          :ratio="16 / 9"
        ></q-img>
      </info-box>
      <info-box caption="Aperture">
        <q-img src="images\brk_aperture_1.jpg" :ratio="16 / 9"></q-img>
        <q-img src="images\brk_aperture_2.jpg" :ratio="16 / 9"></q-img>
        <q-img src="images\brk_aperture_3.jpg" :ratio="16 / 9"></q-img>
      </info-box>
      <info-box caption="Shutter speed">
        <q-img src="images\brk_speed_1.jpg" :ratio="16 / 9"></q-img>
        <q-img src="images\brk_speed_2.jpg" :ratio="16 / 9"></q-img>
        <q-img src="images\brk_speed_3.jpg" :ratio="16 / 9"></q-img>
      </info-box>
    </div>
  </div>
</template>

<script>
import InfoBox from "@/components/InfoBox.vue";
export default {
  components: {
    InfoBox,
  },
};
</script>

<style scoped>
.bracketing-section {
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  justify-items: center;
  grid-gap: var(--content-margin);
  padding: var(--section-padding);
}

.images {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-auto-rows: 1fr;
  grid-gap: var(--content-margin);
  align-self: stretch;
  justify-self: center;
  margin-left: 10%;
  width: 90%;
  margin-right: 10%;
  max-width: 500pt;
}

.image {
  max-height: 200pt;
}
</style>
